<template>
  <!-- 权限管理-行为日志-编辑备注 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="编辑备注"
      width="400px"
      @close="closeDialog"
    >
      <el-form ref="replyForm" label-width="80px" size="small">
        <el-form-item prop="name" label="用户账号">
          <el-input :disabled="true" v-model="formData.name"> </el-input>
        </el-form-item>
        <el-form-item prop="nickname" label="用户备注">
          <el-input
            type="textarea"
            maxlength="100"
            :rows="6"
            show-word-limit
            v-model="formData.nickname"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
export default {
  props: {
    value: {//数据
      type: Object,
      default: undefined
    },
    visible: {//展示标志
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {
        admin_id: '',//用户id
        name: '',//用户名称
        nickname: '',//用户备注
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.dialogInfo) {
        this.formData.admin_id = this.dialogInfo.admin_id
        this.formData.name = this.dialogInfo.name
        this.formData.nickname = this.dialogInfo.nickname
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.formData
      patchApiData(`admin_nickname/${this.dialogInfo.admin_id}`, params).then(res => {
        this.$message.success('保存成功！')
        this.$emit('refresh')
        this.closeDialog()
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>